import { useParams, useNavigate } from 'react-router-dom';
import { Descriptions, Card, Button, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/common/PageHeader';
import { ErrorResult } from '../../components/common/ErrorResult';
import { useOrgDetail } from '../../hooks/useOrganizations';
import dayjs from 'dayjs';

export function OrgDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: org, isLoading, isError, refetch } = useOrgDetail(id!);

  if (isLoading) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  if (isError || !org) return <ErrorResult onRetry={refetch} />;

  return (
    <>
      <PageHeader title={org.name} subtitle={org.slug} extra={<Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/organizations')}>Back</Button>} />
      <Card>
        <Descriptions column={2}>
          <Descriptions.Item label="Owner">{org.owner_email}</Descriptions.Item>
          <Descriptions.Item label="Members">{org.member_count}</Descriptions.Item>
          <Descriptions.Item label="Plan">{org.plan_tier || '-'}</Descriptions.Item>
          <Descriptions.Item label="Invoices Processed">{org.invoices_processed ?? 0}</Descriptions.Item>
          <Descriptions.Item label="Storage Used">{org.storage_used_bytes ? (org.storage_used_bytes / 1024 / 1024).toFixed(1) : '0'} MB</Descriptions.Item>
          <Descriptions.Item label="Created">{dayjs(org.created_at).format('MMM D, YYYY HH:mm')}</Descriptions.Item>
          {org.description && <Descriptions.Item label="Description" span={2}>{org.description}</Descriptions.Item>}
        </Descriptions>
      </Card>
    </>
  );
}
